(function () {
  'use strict';

  // Omien elementtien tapahtumat Shopifyn asiakastapahtumiin (Settings > Customer events > custom pixel voi tilata nämä: eco_*)
  var ecoTrack = function (name, data) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data || {});
      }
    } catch (e) {}
  };
  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest ? ev.target.closest('[data-eco-cart-sticky-btn], .eco-size-hint a, .eco-cart-upsell button, .eco-cart-upsell form button, .eco-sib__pill, .eco-notif-trust, .eco-card-use') : null;
    if (!t) return;
    if (t.hasAttribute('data-eco-cart-sticky-btn')) ecoTrack('eco_cart_sticky_checkout', { page: location.pathname });
    else if (t.closest('.eco-size-hint')) ecoTrack('eco_size_hint_click', { href: t.getAttribute('href') || '', page: location.pathname });
    else if (t.closest('.eco-cart-upsell')) ecoTrack('eco_cart_upsell_add', { page: location.pathname });
    else if (t.classList.contains('eco-sib__pill')) ecoTrack('eco_sibling_switch', { href: t.getAttribute('href') || '', page: location.pathname });
  }, true);

  var heroVideo = document.querySelector('.eco-hero__video');
  if (heroVideo) {
    if (!heroVideo.getAttribute('src')) {
      var srcSd = heroVideo.getAttribute('data-src-sd');
      var srcMd = heroVideo.getAttribute('data-src-md');
      var srcHd = heroVideo.getAttribute('data-src-hd');
      var chosenSrc = srcHd;
      if (window.matchMedia('(max-width: 749px)').matches) {
        chosenSrc = srcSd || srcMd || srcHd;
      } else if (window.matchMedia('(max-width: 1249px)').matches) {
        chosenSrc = srcMd || srcHd;
      }
      var conn = navigator.connection || {};
      var skipVideo = conn.saveData || window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.matchMedia('(max-width: 749px)').matches;
      if (chosenSrc && !skipVideo) {
        // Video ladataan vasta kun sivu on latautunut (poster näkyy sitä ennen) -> ei kilpaile LCP:n/pääsäikeen kanssa
        var startVideo = function () {
          var go = function () {
            heroVideo.src = chosenSrc;
            heroVideo.load();
            heroVideo.play().catch(function () {});
          };
          if ('requestIdleCallback' in window) { window.requestIdleCallback(go, { timeout: 2500 }); } else { setTimeout(go, 600); }
        };
        if (document.readyState === 'complete') { startVideo(); } else { window.addEventListener('load', startVideo, { once: true }); }
      }
    }
    var markReady = function () { heroVideo.classList.add('eco-hero__video--ready'); };
    if (heroVideo.readyState >= 2) {
      markReady();
    } else {
      heroVideo.addEventListener('loadeddata', markReady, { once: true });
    }

    // Taustavideon tauko/toisto (WCAG 2.2.2): painike näkyy vasta kun video oikeasti pyörii
    var heroPause = document.querySelector('[data-eco-hero-pause]');
    if (heroPause) {
      var syncHeroPause = function () {
        var paused = heroVideo.paused;
        heroPause.classList.toggle('eco-hero__pause--paused', paused);
        heroPause.setAttribute('aria-label', heroPause.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
      };
      heroVideo.addEventListener('play', function () { heroPause.hidden = false; syncHeroPause(); });
      heroVideo.addEventListener('pause', syncHeroPause);
      heroPause.addEventListener('click', function () {
        if (heroVideo.paused) { heroVideo.play().catch(function () {}); } else { heroVideo.pause(); }
      });
      if (!heroVideo.paused) { heroPause.hidden = false; syncHeroPause(); }
    }
  }

  var heroContent = document.querySelector('.eco-hero__content');
  if (heroContent) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { heroContent.classList.add('eco-in'); });
    });
  }

  document.querySelectorAll('[data-eco-hero-scroll]').forEach(function (heroScrollCue) {
    heroScrollCue.addEventListener('click', function () {
      var hero = document.querySelector('.eco-hero');
      var target = hero ? hero.nextElementSibling : null;
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollBy({ top: window.innerHeight * 0.9, behavior: 'smooth' });
      }
    });
  });

  var productDesc = document.querySelector('.product__description');
  if (productDesc && productDesc.scrollHeight > 420) {
    var descLang = (document.documentElement.lang || 'fi').slice(0, 2);
    var moreLabel = descLang === 'sv' ? 'Visa mer' : descLang === 'et' ? 'Näita rohkem' : 'Näytä lisää';
    var lessLabel = descLang === 'sv' ? 'Visa mindre' : descLang === 'et' ? 'Näita vähem' : 'Näytä vähemmän';
    productDesc.classList.add('eco-desc-clamp');
    var descToggle = document.createElement('button');
    descToggle.type = 'button';
    descToggle.className = 'eco-desc-toggle';
    descToggle.textContent = moreLabel;
    descToggle.setAttribute('aria-expanded', 'false');
    productDesc.insertAdjacentElement('afterend', descToggle);
    descToggle.addEventListener('click', function () {
      var clamped = productDesc.classList.toggle('eco-desc-clamp');
      descToggle.textContent = clamped ? moreLabel : lessLabel;
      descToggle.setAttribute('aria-expanded', clamped ? 'false' : 'true');
    });
  }

  var headerWrapper = document.querySelector('.header-wrapper');
  if (headerWrapper) {
    var lastScrolled = false;
    var onScroll = function () {
      var scrolled = window.scrollY > 8;
      if (scrolled !== lastScrolled) {
        headerWrapper.classList.toggle('eco-scrolled', scrolled);
        lastScrolled = scrolled;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.eco-reveal, .eco-material, .eco-colors').forEach(function (el) {
      el.classList.add('eco-in');
    });
    return;
  }

  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('eco-in');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
  );

  document.querySelectorAll('.eco-reveal, .eco-material, .eco-colors').forEach(function (el, i) {
    el.style.setProperty('--eco-delay', (i % 6) * 70 + 'ms');
    revealObserver.observe(el);
  });

  document.querySelectorAll('[data-eco-bottle]').forEach(function (el, i) {
    el.style.setProperty('--i', i);
  });

  var counters = document.querySelectorAll('[data-eco-count]');
  if (counters.length) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var runCounter = function (el) {
      var target = parseFloat(el.getAttribute('data-eco-count'));
      var decimals = parseInt(el.getAttribute('data-eco-decimals') || '0', 10);
      if (reduceMotion) {
        el.textContent = target.toFixed(decimals);
        return;
      }
      var duration = 1400;
      var start = null;
      var step = function (ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(decimals);
        if (p < 1) window.requestAnimationFrame(step);
      };
      window.requestAnimationFrame(step);
    };
    var counterObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            runCounter(entry.target);
            counterObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.6 }
    );
    counters.forEach(function (el) { counterObserver.observe(el); });
  }

  var ecoReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ecoFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (ecoFinePointer && !ecoReduce) {
    document.querySelectorAll('.eco-cat').forEach(function (card) {
      var glare = document.createElement('span');
      glare.className = 'eco-cat__glare';
      glare.setAttribute('aria-hidden', 'true');
      card.appendChild(glare);
      var raf = null;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        if (raf) window.cancelAnimationFrame(raf);
        raf = window.requestAnimationFrame(function () {
          card.style.transform =
            'perspective(90rem) rotateX(' + (py * -7).toFixed(2) + 'deg) rotateY(' + (px * 9).toFixed(2) + 'deg) translateY(-4px)';
          glare.style.opacity = '1';
          glare.style.transform = 'translate(' + (px * 60).toFixed(1) + '%, ' + (py * 60).toFixed(1) + '%)';
        });
      });
      card.addEventListener('mouseleave', function () {
        if (raf) window.cancelAnimationFrame(raf);
        card.style.transform = '';
        glare.style.opacity = '0';
      });
    });
  }

  var heroMediaEl = document.querySelector('.eco-hero__media');
  var heroRootEl = document.querySelector('.eco-hero');
  if (heroMediaEl && heroRootEl && !ecoReduce) {
    var heroTicking = false;
    var heroParallax = function () {
      if (heroTicking) return;
      heroTicking = true;
      window.requestAnimationFrame(function () {
        var y = window.scrollY;
        var h = heroRootEl.offsetHeight || 1;
        if (y <= h) {
          heroMediaEl.style.transform = 'translateY(' + (y * 0.28).toFixed(1) + 'px)';
        }
        heroTicking = false;
      });
    };
    window.addEventListener('scroll', heroParallax, { passive: true });
  }

  var stickyBar = document.querySelector('[data-eco-sticky-atc]');
  if (stickyBar) {
    // Tuotetietojen kääreessä on Dawnin slide-in-animaation transform, joka sitoisi position: fixed -palkin kääreeseen -> siirretään bodyyn
    if (stickyBar.parentNode !== document.body) { document.body.appendChild(stickyBar); }
    var trigger = document.querySelector('[data-eco-sticky-trigger]');
    var mainSubmit = document.querySelector('product-form .product-form__submit');
    if (mainSubmit) {
      // Palkki näkyy aina kun varsinainen ostonappi ei ole näkyvissä – myös sivun alussa ennen vieritystä
      var submitObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            stickyBar.classList.toggle('eco-visible', !entry.isIntersecting && !mainSubmit.disabled);
            document.body.classList.toggle('eco-sticky-on', !entry.isIntersecting && !mainSubmit.disabled);
          });
        },
        { threshold: 0 }
      );
      submitObserver.observe(mainSubmit);
    } else if (trigger) {
      var stickyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            stickyBar.classList.toggle('eco-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          document.body.classList.toggle('eco-sticky-on', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          });
        },
        { threshold: 0 }
      );
      stickyObserver.observe(trigger);
    }

    var stickyBtn = stickyBar.querySelector('[data-eco-sticky-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        // Huom: sivun ensimmäinen /cart/add-lomake on osamaksulomake ilman submit-nappia -> haetaan nappi suoraan product-formista
        var submit = mainSubmit || document.querySelector('product-form form [type="submit"]');
        ecoTrack('eco_sticky_atc_click', { page: location.pathname });
        if (submit) {
          submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
          window.setTimeout(function () { submit.click(); }, 400);
        }
      });
    }
  }

  // Ostoskorisivu: kiinteä Kassa-palkki mobiilissa, näkyy kun varsinainen Kassa-nappi ei ole ruudulla
  var cartSticky = document.querySelector('[data-eco-cart-sticky]');
  if (cartSticky && 'IntersectionObserver' in window) {
    if (cartSticky.parentNode !== document.body) { document.body.appendChild(cartSticky); }
    var cartStickyTotal = cartSticky.querySelector('[data-eco-cart-sticky-total]');
    var cartCheckoutObserver = null;
    var cartCheckoutVisible = true;
    var cartStickyRefresh = function () {
      var footer = document.getElementById('main-cart-footer');
      var checkoutBtn = footer ? footer.querySelector('#checkout') : null;
      var cartItems = document.querySelector('cart-items');
      var cartEmpty = !checkoutBtn || checkoutBtn.disabled || (cartItems && cartItems.classList.contains('is-empty'));
      var totalEl = footer ? footer.querySelector('.totals__total-value') : null;
      if (totalEl && cartStickyTotal) { cartStickyTotal.textContent = totalEl.textContent.trim(); }
      if (cartCheckoutObserver) { cartCheckoutObserver.disconnect(); cartCheckoutObserver = null; }
      if (cartEmpty) {
        cartSticky.classList.remove('eco-visible');
        document.body.classList.remove('eco-cart-sticky-on', 'eco-sticky-on');
        return;
      }
      document.body.classList.add('eco-cart-sticky-on');
      cartCheckoutObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          cartCheckoutVisible = entry.isIntersecting;
          cartSticky.classList.toggle('eco-visible', !cartCheckoutVisible);
          document.body.classList.toggle('eco-sticky-on', !cartCheckoutVisible);
        });
      }, { threshold: 0 });
      cartCheckoutObserver.observe(checkoutBtn);
    };
    cartStickyRefresh();
    var cartFooterEl = document.getElementById('main-cart-footer');
    if (cartFooterEl) {
      new MutationObserver(function () { window.setTimeout(cartStickyRefresh, 50); }).observe(cartFooterEl, { childList: true, subtree: true });
    }
    var cartItemsEl = document.querySelector('cart-items');
    if (cartItemsEl) {
      new MutationObserver(function () { window.setTimeout(cartStickyRefresh, 50); }).observe(cartItemsEl, { attributes: true, attributeFilter: ['class'] });
    }
  }

  // Viimeksi katsotut tuotteet (localStorage eco_recent, max 8) – tuotesivu ja tyhjä ostoskori
  var recentBox = document.querySelector('[data-eco-recent]');
  if (recentBox) {
    var RECENT_KEY = 'eco_recent';
    var readRecent = function () { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; } };
    var list = readRecent();
    var cur = recentBox.getAttribute('data-eco-recent-current');
    var curItem = recentBox.getAttribute('data-eco-recent-item');
    if (cur && curItem) {
      try {
        var item = JSON.parse(curItem);
        list = list.filter(function (x) { return x && x.h !== item.h; });
        list.unshift(item);
        list = list.slice(0, 8);
        localStorage.setItem(RECENT_KEY, JSON.stringify(list));
      } catch (e) {}
    }
    var show = list.filter(function (x) { return x && x.h && x.h !== cur && x.a !== 0; }).slice(0, 6);
    if (show.length) {
      var ul = recentBox.querySelector('[data-eco-recent-list]');
      ul.innerHTML = show.map(function (x) {
        var img = x.i ? '<img src="' + x.i + '" alt="" loading="lazy" width="160" height="160">' : '';
        var price = x.a === 0 ? '' : '<span class="eco-recent__price">' + (x.p || '') + '</span>';
        return '<li class="eco-recent__item"><a class="eco-recent__link" href="' + x.u + '"><span class="eco-recent__img">' + img + '</span><span class="eco-recent__title">' + x.t + '</span>' + price + '</a></li>';
      }).join('');
      recentBox.hidden = false;
    }
  }

  // Artikkelin sisällysluettelo, kun väliotsikoita on vähintään 4 (9.10.2026)
  var artContent = document.querySelector('.article-template__content');
  if (artContent) {
    var h2s = Array.prototype.slice.call(artContent.querySelectorAll('h2'));
    if (h2s.length >= 4) {
      var lang = (document.documentElement.lang || 'fi').slice(0, 2);
      var tocTitle = lang === 'sv' ? 'Innehåll' : lang === 'et' ? 'Sisukord' : 'Sisältö';
      var nav = document.createElement('nav');
      nav.className = 'eco-toc';
      nav.setAttribute('aria-label', tocTitle);
      var used = {};
      nav.innerHTML = '<p class="eco-toc__title">' + tocTitle + '</p><ol class="eco-toc__list">' + h2s.map(function (h, i) {
        var base = (h.textContent || '').toLowerCase().replace(/[^a-z0-9äöåõüš]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || ('osa-' + i);
        var id = h.id || base; var n = 1; while (used[id] || (!h.id && document.getElementById(id))) { id = base + '-' + (++n); }
        used[id] = true; h.id = id;
        return '<li><a href="#' + id + '">' + (h.textContent || '').replace(/</g, '&lt;') + '</a></li>';
      }).join('') + '</ol>';
      artContent.insertBefore(nav, artContent.firstChild);
    }
  }

  // Mittapiirros-linkki: näytä gallerian mittapiirroskuva
  document.addEventListener('click', function (ev) {
    var a = ev.target && ev.target.closest ? ev.target.closest('[data-eco-dims-media]') : null;
    if (!a) return;
    ev.preventDefault();
    var id = a.getAttribute('data-eco-dims-media');
    var gallery = document.querySelector('media-gallery');
    if (gallery) {
      // id = "<sectionId>-<mediaId>" kuten Dawnin li.product__media-item[data-media-id]
      var sl = gallery.querySelector('li[data-media-id="' + id + '"]');
      // Dawnin setActiveMedia olettaa pikkukuvat; mobiilissa ne on piilotettu -> mahdollinen virhe napataan
      try { if (typeof gallery.setActiveMedia === 'function') { gallery.setActiveMedia(id, false); } } catch (e) {}
      if (sl) {
        if (!sl.classList.contains('is-active')) {
          gallery.querySelectorAll('li.product__media-item').forEach(function (li) { li.classList.remove('is-active'); });
          sl.classList.add('is-active');
        }
        window.setTimeout(function () { sl.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' }); }, 60);
      }
    }
  });

  // Vertaa ruukkuja (9.10.2026): max 3 tuotetta localStoragessa (eco_cmp), palkki + taulukko luodaan JS:llä
  (function () {
    var CMP_KEY = 'eco_cmp';
    var L = (document.documentElement.lang || 'fi').slice(0, 2);
    var T = L === 'sv' ? { bar: 'Jämför', clear: 'Rensa', title: 'Jämför krukor', dims: 'Mått', vol: 'Volym', kg: 'Vikt', price: 'Pris', open: 'Till produkten', remove: 'Ta bort', max: 'Du kan jämföra högst 3 krukor', h: 'h', close: 'Stäng' }
          : L === 'et' ? { bar: 'Võrdle', clear: 'Tühjenda', title: 'Võrdle potte', dims: 'Mõõdud', vol: 'Maht', kg: 'Kaal', price: 'Hind', open: 'Toote juurde', remove: 'Eemalda', max: 'Võrrelda saab kuni 3 potti', h: 'k', close: 'Sulge' }
          : { bar: 'Vertaa', clear: 'Tyhjennä', title: 'Vertaa ruukkuja', dims: 'Mitat', vol: 'Tilavuus', kg: 'Paino', price: 'Hinta', open: 'Tuotteeseen', remove: 'Poista', max: 'Voit vertailla enintään 3 ruukkua', h: 'k', close: 'Sulje' };
    var read = function () { try { return JSON.parse(localStorage.getItem(CMP_KEY) || '[]'); } catch (e) { return []; } };
    var write = function (list) { try { localStorage.setItem(CMP_KEY, JSON.stringify(list)); } catch (e) {} };
    var buttons = document.querySelectorAll('[data-eco-cmp]');
    var bar = null, overlay = null;
    var ensureBar = function () {
      if (bar) return bar;
      bar = document.createElement('div'); bar.className = 'eco-cmp-bar'; bar.hidden = true;
      bar.innerHTML = '<button type="button" class="eco-cmp-bar__open" data-eco-cmp-open>' + T.bar + ' (<span data-eco-cmp-n>0</span>)</button><button type="button" class="eco-cmp-bar__clear" data-eco-cmp-clear>' + T.clear + '</button>';
      document.body.appendChild(bar);
      bar.querySelector('[data-eco-cmp-clear]').addEventListener('click', function () { write([]); sync(); });
      bar.querySelector('[data-eco-cmp-open]').addEventListener('click', openOverlay);
      return bar;
    };
    var sync = function () {
      var list = read(); var hs = {}; list.forEach(function (x) { hs[x.h] = true; });
      buttons.forEach(function (b) { try { var d = JSON.parse(b.getAttribute('data-eco-cmp')); b.setAttribute('aria-pressed', hs[d.h] ? 'true' : 'false'); b.classList.toggle('eco-cmp--on', !!hs[d.h]); } catch (e) {} });
      if (list.length || bar) { var el = ensureBar(); el.hidden = list.length === 0; el.querySelector('[data-eco-cmp-n]').textContent = list.length; document.body.classList.toggle('eco-cmp-on', list.length > 0); }
      if (overlay && !overlay.hidden) renderOverlay();
    };
    var dimsText = function (x) { return (x.r == 1 ? 'Ø ' + x.w : x.l + ' × ' + x.w) + ' × ' + T.h + ' ' + x.hh + ' cm'; };
    var renderOverlay = function () {
      var list = read();
      var head = '<tr><th></th>' + list.map(function (x) { return '<th><a href="' + x.u + '"><img src="' + (x.i || '') + '" alt="" width="120" height="120" loading="lazy"><span>' + x.t + '</span></a></th>'; }).join('') + '</tr>';
      var row = function (label, fn) { return '<tr><th scope="row">' + label + '</th>' + list.map(function (x) { return '<td>' + fn(x) + '</td>'; }).join('') + '</tr>'; };
      overlay.querySelector('[data-eco-cmp-table]').innerHTML = '<thead>' + head + '</thead><tbody>' + row(T.dims, dimsText) + row(T.vol, function (x) { return x.v && x.v != 0 ? x.v + ' l' : '–'; }) + row(T.kg, function (x) { return x.kg ? x.kg + ' kg' : '–'; }) + row(T.price, function (x) { return x.p || ''; }) + row('', function (x) { return '<a class="button button--secondary eco-cmp__go" href="' + x.u + '">' + T.open + '</a><br><button type="button" class="link eco-cmp__rm" data-eco-cmp-rm="' + x.h + '">' + T.remove + '</button>'; }) + '</tbody>';
      if (!list.length) overlay.hidden = true;
    };
    var openOverlay = function () {
      if (!overlay) {
        overlay = document.createElement('div'); overlay.className = 'eco-cmp-overlay'; overlay.setAttribute('role', 'dialog'); overlay.setAttribute('aria-modal', 'true'); overlay.setAttribute('aria-label', T.title);
        overlay.innerHTML = '<div class="eco-cmp-overlay__box"><div class="eco-cmp-overlay__head"><h2>' + T.title + '</h2><button type="button" class="eco-cmp-overlay__close" data-eco-cmp-close aria-label="' + T.close + '">&times;</button></div><div class="eco-cmp-overlay__scroll"><table class="eco-cmp-table" data-eco-cmp-table></table></div></div>';
        document.body.appendChild(overlay);
        overlay.addEventListener('click', function (ev) {
          if (ev.target === overlay || ev.target.closest('[data-eco-cmp-close]')) { overlay.hidden = true; return; }
          var rm = ev.target.closest('[data-eco-cmp-rm]'); if (rm) { write(read().filter(function (x) { return x.h !== rm.getAttribute('data-eco-cmp-rm'); })); sync(); }
        });
        document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && overlay && !overlay.hidden) overlay.hidden = true; });
      }
      overlay.hidden = false; renderOverlay();
    };
    buttons.forEach(function (b) {
      b.addEventListener('click', function () {
        var d; try { d = JSON.parse(b.getAttribute('data-eco-cmp')); } catch (e) { return; }
        var list = read(); var i = list.findIndex(function (x) { return x.h === d.h; });
        if (i >= 0) list.splice(i, 1); else { if (list.length >= 3) { alert(T.max); return; } list.push(d); }
        write(list); sync();
      });
    });
    if (buttons.length || read().length) sync();
  })();

  // Osta yhdessä: lisää molemmat koriin yhdellä napilla -> ostoskorisivu
  document.addEventListener('click', function (ev) {
    var b = ev.target && ev.target.closest ? ev.target.closest('[data-eco-bundle-all]') : null;
    if (!b) return;
    var ids = (b.getAttribute('data-variants') || '').split(',').filter(Boolean);
    if (!ids.length) return;
    b.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }) }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); ecoTrack('eco_bundle_add_both', { page: location.pathname }); window.location.href = b.getAttribute('data-cart-url') || '/cart'; })
      .catch(function () { b.disabled = false; });
  });

  // Ruukkukoon laskuri (kokoopas)
  var calc = document.querySelector('[data-eco-calc]');
  if (calc) {
    var lang = calc.getAttribute('data-lang') || 'fi'; var root = (calc.getAttribute('data-root') || '/').replace(/\/$/, '');
    var ranges = { huone: [4, 6], nopea: [6, 10], yrtti: [2, 4], parveke: [4, 6] };
    var coll = function (d) { return d <= 20 ? 'ecopots-pienet-ruukut-8-20cm' : d <= 40 ? 'ecopots-keskikokoiset-ruukut-20-40cm' : d <= 70 ? 'ecopots-isot-ruukut-40-70cm' : 'ecopots-extra-isot-ruukut-70cm'; };
    calc.querySelector('[data-eco-calc-form]').addEventListener('submit', function (ev) {
      ev.preventDefault();
      var d = parseFloat(calc.querySelector('#eco-calc-d').value); var k = calc.querySelector('#eco-calc-p').value; var r = ranges[k] || ranges.huone;
      if (!d || d < 5) return;
      var lo = Math.round(d + r[0]), hi = Math.round(d + r[1]);
      var note = lang === 'sv' ? ' Ute: ta bort bottenpluggen. Inne: plugg i och fat under.' : lang === 'et' ? ' Õues: eemalda põhjakork. Toas: kork kinni ja alus alla.' : ' Ulkona: irrota pohjatulppa. Sisällä: tulppa kiinni ja aluslautanen alle.';
      calc.querySelector('[data-eco-calc-text]').textContent = 'Ø ' + lo + '–' + hi + ' cm.' + note;
      calc.querySelector('[data-eco-calc-link]').setAttribute('href', root + '/collections/' + coll(Math.round((lo + hi) / 2)));
      calc.querySelector('[data-eco-calc-result]').hidden = false;
      ecoTrack('eco_size_calc', { d: d, plant: k });
    });
  }

  var docLang = (document.documentElement.lang || 'fi').slice(0, 2);

  // Tuotesivun galleria (työpöytä): näytä 6 pikkukuvaa, loput "+N kuvaa" -painikkeen takaa
  var thumbList = document.querySelector('.thumbnail-list');
  if (thumbList && window.matchMedia('(min-width: 750px)').matches) {
    var thumbs = thumbList.querySelectorAll('.thumbnail-list__item');
    var THUMB_LIMIT = 6;
    if (thumbs.length > THUMB_LIMIT + 1) {
      var hiddenThumbs = [];
      thumbs.forEach(function (t, i) { if (i >= THUMB_LIMIT) { t.classList.add('eco-thumb-hidden'); hiddenThumbs.push(t); } });
      var moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.className = 'eco-thumb-more';
      moreBtn.textContent = '+' + hiddenThumbs.length + (docLang === 'sv' ? ' bilder' : docLang === 'et' ? ' pilti' : ' kuvaa');
      moreBtn.addEventListener('click', function () {
        hiddenThumbs.forEach(function (t) { t.classList.remove('eco-thumb-hidden'); });
        moreBtn.remove();
      });
      thumbList.parentNode.insertBefore(moreBtn, thumbList.nextSibling);
    }
  }

  // Kokoelmasivun kuvaus (mobiili): 2 riviä + "Lue lisää"
  var colDesc = document.querySelector('.collection-hero__description');
  if (colDesc && window.matchMedia('(max-width: 749px)').matches) {
    colDesc.classList.add('eco-clamp');
    if (colDesc.scrollHeight > colDesc.clientHeight + 4) {
      var descMore = document.createElement('button');
      descMore.type = 'button';
      descMore.className = 'eco-desc-more';
      descMore.textContent = docLang === 'sv' ? 'Läs mer' : docLang === 'et' ? 'Loe lisaks' : 'Lue lisää';
      descMore.addEventListener('click', function () { colDesc.classList.remove('eco-clamp'); descMore.remove(); });
      colDesc.parentNode.insertBefore(descMore, colDesc.nextSibling);
    } else {
      colDesc.classList.remove('eco-clamp');
    }
  }
})();

/* Ruotsin kauppa: ostoskorin todellinen toimitushinta Shopifyn shipping_rates-rajapinnasta (snippets/eco-delivery.liquid) */
(function () {
  'use strict';
  var busy = false;
  function fmt(v) { return Math.round(parseFloat(v)).toLocaleString('sv-SE') + '\u00a0kr'; }
  function fill() {
    var el = document.querySelector('[data-eco-ship-live]:not([data-eco-done])');
    if (!el || busy) return;
    busy = true;
    el.setAttribute('data-eco-done', '1');
    fetch('/cart/shipping_rates.json?shipping_address%5Bcountry%5D=SE&shipping_address%5Bzip%5D=11122', {credentials: 'same-origin'})
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var rates = (d && d.shipping_rates) || [];
        if (!rates.length) return;
        var collect = rates.filter(function (x) { return /collect/i.test(x.name); })[0] || rates[0];
        var home = rates.filter(function (x) { return /home/i.test(x.name); })[0];
        el.textContent = 'Frakt för din varukorg: ' + fmt(collect.price) + ' till utlämningsställe' + (home ? ', ' + fmt(home.price) + ' hemleverans' : '') + ' (PostNord, 2–5 arbetsdagar). Slutpriset bekräftas i kassan.';
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill); else fill();
  new MutationObserver(fill).observe(document.documentElement, {childList: true, subtree: true});
})();

/* ERÄ 12 (12.10.2026): Lataa lisää kokoelmiin + uutiskirjeen poistumiskehote (desktop) */
(function () {
  var pub = function (name, data) { try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, data || {}); } catch (e) {} };
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-eco-more]');
    if (!b) return;
    ev.preventDefault();
    var url = b.getAttribute('data-eco-more'), sid = b.getAttribute('data-eco-more-section');
    if (!url || b.disabled) return;
    b.disabled = true; b.classList.add('eco-more--loading');
    var u = new URL(url, location.origin); u.searchParams.set('section_id', sid);
    fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = document.getElementById('product-grid');
      var items = doc.querySelectorAll('#product-grid > li');
      if (!grid || !items.length) { location.href = url; return; }
      items.forEach(function (li, i) { li.classList.add('eco-in'); li.style.setProperty('--eco-delay', (i % 8) * 60 + 'ms'); grid.appendChild(li); });
      var wrap = b.closest('[data-eco-more-wrap]'), nb = doc.querySelector('[data-eco-more]');
      if (nb) {
        b.setAttribute('data-eco-more', nb.getAttribute('data-eco-more'));
        var c = wrap && wrap.querySelector('.eco-more__count'), nc = doc.querySelector('.eco-more__count');
        if (c && nc) c.textContent = nc.textContent;
        b.disabled = false;
      } else if (wrap) { wrap.remove(); }
      b.classList.remove('eco-more--loading');
      var pu = new URL(url, location.origin); pu.searchParams.delete('section_id');
      try { history.replaceState(null, '', pu.pathname + pu.search); } catch (e) {}
      try { if (window.jdgm && typeof window.jdgm.init === 'function') window.jdgm.init(); } catch (e) {}
      pub('eco_load_more', { page: pu.searchParams.get('page') });
      document.dispatchEvent(new CustomEvent('eco:gridappend'));
    }).catch(function () { location.href = url; });
  });

  var m = document.getElementById('eco-nlm');
  if (!m) return;
  if (location.search.indexOf('customer_posted=true') > -1) {
    try { if (sessionStorage.getItem('eco_nl_modal')) { localStorage.setItem('eco_nl_done', '1'); sessionStorage.removeItem('eco_nl_modal'); m.hidden = false; document.body.classList.add('eco-nlm-open'); } } catch (e) {}
  }
  var allowed = true;
  try { if (localStorage.getItem('eco_nl_done')) allowed = false; var seen = parseInt(localStorage.getItem('eco_nl_seen') || '0', 10); if (Date.now() - seen < 30 * 864e5) allowed = false; } catch (e) {}
  if (window.innerWidth < 990 || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) allowed = false;
  var start = Date.now(), shown = false;
  var open = function () { if (shown || !allowed) return; shown = true; m.hidden = false; document.body.classList.add('eco-nlm-open'); try { localStorage.setItem('eco_nl_seen', String(Date.now())); } catch (e) {} var f = m.querySelector('input[type=email]'); if (f) f.focus(); pub('eco_nl_modal_open'); };
  var close = function () { m.hidden = true; document.body.classList.remove('eco-nlm-open'); };
  document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0 && Date.now() - start > 15000) open(); });
  m.addEventListener('click', function (e) { if (e.target.closest('[data-eco-nlm-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) close(); });
  var form = m.querySelector('form');
  if (form) form.addEventListener('submit', function () { try { sessionStorage.setItem('eco_nl_modal', '1'); } catch (e) {} });
})();

/* ERÄ 13 (12.10.2026): etusivun jatka-nauha + korttien värinvaihto hoverissa */
(function () {
  var box = document.querySelector('[data-eco-continue]');
  if (box) {
    var list = box.querySelector('[data-eco-continue-list]'), cartA = box.querySelector('[data-eco-continue-cart]');
    var items = [];
    try { items = JSON.parse(localStorage.getItem('eco_recent') || '[]'); } catch (e) {}
    items = (items || []).filter(function (x) { return x && x.h && x.a !== 0; }).slice(0, 4);
    var any = false;
    if (items.length) {
      list.innerHTML = items.map(function (x) {
        var img = x.i ? '<img src="' + x.i + '" alt="" width="40" height="40" loading="lazy">' : '';
        return '<li class="eco-continue__item"><a href="' + x.u + '">' + img + '<span>' + (x.t || '') + '</span></a></li>';
      }).join('');
      any = true;
    }
    var show = function () { if (any) box.hidden = false; };
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (c && c.item_count > 0) {
        var n = c.item_count, word = n === 1 ? box.getAttribute('data-t-one') : box.getAttribute('data-t-many');
        cartA.textContent = box.getAttribute('data-t-cart').replace('{n}', n + ' ' + word) + ' · ' + box.getAttribute('data-t-go') + ' →';
        cartA.hidden = false; any = true;
      }
      show();
    }).catch(show);
  }

  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseover', function (ev) {
      var dot = ev.target.closest('.eco-sib__dot[data-eco-img]');
      if (!dot) return;
      var card = dot.closest('.card-wrapper'); if (!card) return;
      var img = card.querySelector('.card__media img'); if (!img) return;
      if (!img.dataset.ecoOrig) { img.dataset.ecoOrig = img.getAttribute('src') || ''; img.dataset.ecoOrigSet = img.getAttribute('srcset') || ''; }
      img.setAttribute('srcset', ''); img.setAttribute('src', dot.getAttribute('data-eco-img'));
    });
    document.addEventListener('mouseout', function (ev) {
      var dot = ev.target.closest('.eco-sib__dot[data-eco-img]');
      if (!dot) return;
      var to = ev.relatedTarget; if (to && to.closest && to.closest('.eco-sib__dot[data-eco-img]')) return;
      var card = dot.closest('.card-wrapper'); if (!card) return;
      var img = card.querySelector('.card__media img'); if (!img || !img.dataset.ecoOrig) return;
      img.setAttribute('src', img.dataset.ecoOrig); img.setAttribute('srcset', img.dataset.ecoOrigSet);
    });
  }
})();

/* ERÄ 16 (3.11.2026): artikkelin mobiilin alapalkki (näkyy, kun keskikortti on ohitettu; piiloon, kun loppuosan tuotteet näkyvät) + keskikortin klikkimittaus */
(function () {
  var pub = function (name, data) { try { if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') window.Shopify.analytics.publish(name, data || {}); } catch (e) {} };
  var mid = document.querySelector('[data-eco-art-mid]');
  var bar = document.querySelector('[data-eco-art-bar]');
  if (!mid) return;
  mid.addEventListener('click', function (e) { if (e.target.closest('[data-eco-art-mid-link]')) pub('eco_article_mid_click', { page: location.pathname }); });
  if (!bar || !('IntersectionObserver' in window) || !window.matchMedia('(max-width: 749px)').matches) return;
  var dismissed = false;
  try { dismissed = !!sessionStorage.getItem('eco_art_bar'); } catch (e) {}
  if (dismissed) return;
  if (bar.parentNode !== document.body) document.body.appendChild(bar);
  var passed = false, bottomVisible = false, shownOnce = false;
  var update = function () {
    var show = passed && !bottomVisible;
    if (show && bar.hidden) { bar.hidden = false; }
    requestAnimationFrame(function () { bar.classList.toggle('eco-visible', show); document.body.classList.toggle('eco-art-bar-on', show); });
    if (show && !shownOnce) { shownOnce = true; pub('eco_article_bar_show', { page: location.pathname }); }
  };
  new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { passed = !en.isIntersecting && en.boundingClientRect.top < 0; });
    update();
  }, { threshold: 0 }).observe(mid);
  var bottom = document.querySelector('.eco-article-products, .eco-article-next, .eco-article-newsletter');
  if (bottom) {
    new IntersectionObserver(function (entries) { entries.forEach(function (en) { bottomVisible = en.isIntersecting || en.boundingClientRect.top < 0; }); update(); }, { threshold: 0 }).observe(bottom);
  }
  bar.addEventListener('click', function (e) {
    if (e.target.closest('[data-eco-art-bar-close]')) {
      bar.classList.remove('eco-visible'); document.body.classList.remove('eco-art-bar-on');
      try { sessionStorage.setItem('eco_art_bar', '1'); } catch (err) {}
      passed = false;
    } else if (e.target.closest('[data-eco-art-bar-link]')) {
      pub('eco_article_bar_click', { page: location.pathname });
    }
  });
})();
